import { getAll, getItem, setItem, removeItem } from '@rambler-id/cookies';
export class Splits {
    constructor(settings) {
        this.settings = settings;
        this.variations = this.settings.tests.reduce((accumulator, { name, cookie, variations }) => {
            accumulator[name] = this.chooseVariation(variations, this.getProbability(cookie || name, this.settings.options));
            return accumulator;
        }, {});
        this.dropIrrelevantProbabilities();
    }
    getVariations() {
        return this.variations;
    }
    dropIrrelevantProbabilities() {
        const items = getAll();
        const { tests, options: { prefix = '', ...options } } = this.settings;
        if (items) {
            const removal = Object.keys(items).filter((cookieName) => cookieName.indexOf(prefix) === 0 &&
                !tests.filter(({ name, cookie }) => cookieName === `${prefix}${cookie || name}`).length);
            removal.forEach((cookieName) => removeItem(cookieName, options));
        }
    }
    getProbability(name, { prefix = '', ...options }) {
        const cookieName = `${prefix}${name}`;
        let probability = getItem(cookieName);
        if (!probability || typeof probability !== 'number') {
            probability = Math.random();
        }
        setItem(cookieName, probability, options);
        return probability;
    }
    chooseVariation(variations, probability) {
        return variations.reduce((accumulator, { name, probability: [start, end] }) => probability >= start && probability < end ? name : accumulator, 'default');
    }
}
